import { render } from "./CookiesMessage.vue?vue&type=template&id=1cf64c54&scoped=true"
import script from "./CookiesMessage.vue?vue&type=script&lang=js"
export * from "./CookiesMessage.vue?vue&type=script&lang=js"

import "./CookiesMessage.vue?vue&type=style&index=0&id=1cf64c54&scoped=true&lang=scss"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cf64c54"]])

export default __exports__